const translations = {
    noApplications: 'No applications'
};

export default translations;
